/**
 * 批量删除
 */
import React from 'react';
import {Button} from "antd";
import CmModal from "../../../../components/CmModal/CmModal";
import {message} from "../../../../view/sysManagement/utils/sysManagementUtils";
import BaseComponent from "../../../../base/BaseComponent";

export default class BatchDelete extends BaseComponent {
    static propTypes = {};
    static defaultProps = {};

    constructor(props) {
        super(props);
        this.state = {
            batchDeleteVisible: false,
            tsUserList: props.tsUserList
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            tsUserList: nextProps.tsUserList
        })
    }

    batchDeleteHandle = () => {
        const {tsUserList} = this.state;
        console.log(tsUserList)
        if (!tsUserList.length) {
            message.warn('请选择用户！');
            return false
        }
        if (tsUserList.length) {
            this.setState({
                batchDeleteVisible: true
            });
        }
    };

    handleCancel = () => {
        this.setState({
            batchDeleteVisible: false
        });
    };

    /**
     * 批量删除
     */
    batchDelete = () => {
        const ids = [];
        const {tsUserList} = this.state;
        tsUserList.forEach(function (item) {
            ids.push(item.id);
        });
        if (ids.length > 0) {
            this.request({
                url: "/cm-sites-mmp/rmUser/batchRemove",
                body: ids,
                method: "post",
                contentType: "json",
                callBack: (res) => {
                    if (res) {
                        message.success("用户删除成功");
                        this.props.refreshList();
                        this.handleCancel();
                    }
                }
            });
        }
    };

    render() {
        return (
            <>
                <Button style={{marginRight: "20px"}} onClick={this.batchDeleteHandle}>
                    批量删除用户
                </Button>
                {/*批量删除用户弹窗*/}
                <CmModal
                    handleOk={this.batchDelete}
                    handleCancel={this.handleCancel}
                    visible={this.state.batchDeleteVisible}
                    title="批量删除用户"
                    width={500}
                >
                    <div>以下用户将被删除：</div>
                    <div style={{margin: '5px 0'}}>
                        {this.state.tsUserList.map(item => item.nickName).join("，")}
                    </div>
                </CmModal>
            </>
        )
    }
}